// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emerald .em-select.em-angularjs-select .dropdown-menu{left:0;right:0;max-height:400px;overflow:auto}.emerald .em-select.em-angularjs-select .dropdown-menu .dropdown-item{cursor:pointer;padding:12px !important}.em-select .btn:hover{border-color:#86d1cd !important}", ""]);
// Exports
module.exports = exports;
